const carsHomePageUrl='/cars/used-cars/';
const baseUrl = location.hostname==="localhost" ? "https://www.quikr.com" :location.origin;
const missedCallNumer = '07799740025';

module.exports = Object.assign({
    carsHomePageUrl,
    baseUrl,
    missedCallNumer
});



// WEBPACK FOOTER //
// ../q-cars/src/constants/constants.js